<template>
  <div v-bind:class="{loading: isLoading}" id="view-category" class="columns">
    <div class="column">
      <h2 class="subtitle" id="set-anchor">{{ setName }}</h2>
      <div v-if="notification" class="notification is-info">
        <button @click="notification = ''" class="delete"></button>
        {{ notification }}
      </div>
      <table class="table">
        <thead>
          <tr>
            <th width="50"></th>
            <th width="75">Qty</th>
            <th class="clickable" width="75" @click="sortBy('available-quantity')">Avail</th>
            <th class="clickable" @click="sortBy('product-title')">Name</th>
            <th class="clickable" @click="sortBy('condition')">Cond</th>
            <th class="clickable" @click="sortBy('price')">Price</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="p in orderedProducts">
            <td><button :disabled="p.quantity < 1 || p.quantity > p.available_quantity" @click.prevent="addToCart(p)" class="button is-primary"><i class="fa fa-cart-plus" aria-hidden="true"></i></button></td>
            <td><input class="input quantity" type="number" v-model.number="p.quantity"></td>
            <td>{{ p.available_quantity }}</td>
            <td><card-title :title="p.title" :image-url="p.image"></card-title></td>
            <td>{{ p.variant.title }}</td>
            <td>${{ p.variant.price}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Raven from 'raven-js';
import Client from 'shopify-buy';
import CardTitle from './partials/CardTitle';
import processProduct from '../process-product';

export default {
  name: 'buybrowse',
  data() {
    return {
      isLoading: false,
      category: {},
      products: [],
      checkout: {},
      client: null,
      setName: '',
      notification: '',

      sortKey: '',
      sortDirection: 1, // -1 for reverse
    };
  },
  components: {
    'card-title': CardTitle,
  },
  computed: {
    orderedProducts() {
      if (!this.sortKey) {
        return this.products;
      }

      const sk = this.sortKey;
      const getValue = (k, o) => {
        if (k === 'available-quantity') {
          return o.available_quantity;
        } else if (k === 'product-title') {
          return o.variant.productTitle;
        } else if (k === 'condition') {
          return o.variant.title;
        } else if (k === 'price') {
          return Number(o.variant.formattedPrice.substr(1));
        }

        return '';
      };

      return this.products.sort((a, b) => {
        if (getValue(sk, a) < getValue(sk, b)) {
          return 1 * this.sortDirection;
        } else if (getValue(sk, a) > getValue(sk, b)) {
          return -1 * this.sortDirection;
        }

        return 0;
      });
    },
  },
  methods: {
    addToCart(p) {
      this.client.checkout.addLineItems(
        localStorage.getItem('shopifyCheckoutId'),
        [{ variantId: p.variant.id, quantity: p.quantity }],
      );

      this.notification = `${p.title} has been added to your shopping cart.`;
    },
    sortBy(key) {
      this.sortKey = key;
      this.sortDirection = this.sortDirection * -1;
    },
    loadSet(id) {
      this.isLoading = true;
      this.setName = '';
      this.products = [];
      let cards;

      this.axios.get(`https://inventory.powernine.com/shopify/sets/${id}`).then((response) => {
        this.setName = response.data.name;
        cards = response.data.products;
        const cardsCopy = cards.slice();

        const processProducts = (products) => {
          products.forEach(processProduct(cards, this.products));
        };

        while (cardsCopy.length) {
          const part = cardsCopy.splice(0, 30);

          this.client.product.fetchMultiple(
            part.map(p => btoa(`gid://shopify/Product/${p.product_id}`)),
          ).then(processProducts);
        }

        return this.client.checkout.fetch(localStorage.getItem('shopifyCheckoutId'));
      }).then((checkout) => {
        this.checkout = checkout;
        this.isLoading = false;
        document.getElementById('set-anchor').scrollIntoView();
      })
      .catch((err) => {
        this.isLoading = false;
        Raven.captureException(err);
        throw err;
      });
    },
  },
  mounted() {
    this.client = Client.buildClient({
      storefrontAccessToken: 'c532a34d42a102560faf84bbb93624f1',
      domain: 'powernine.myshopify.com',
      appId: '6',
    });

    if (localStorage.getItem('shopifyCheckoutId') === 'undefined') {
      this.client.checkout.create().then((checkout) => {
        localStorage.setItem('shopifyCheckoutId', checkout.id);
      });
    }

    this.loadSet(this.$route.params.id);
  },
  watch: {
    // eslint-disable-next-line
    '$route': function (to) {
      this.loadSet(to.params.id);
    },
  },
};
</script>



// WEBPACK FOOTER //
// ViewCategory.vue?0550b730